const NHAN_VAI_TRO = {
  admin: "Quản trị viên",
  ban_giam_doc: "Ban giám đốc",
  ke_toan: "Kế toán",
  nhan_vien: "Nhân viên thu mua",
  kho: "Nhân viên kho",
};

export function nhanVaiTro(vaiTro) {
  return NHAN_VAI_TRO[vaiTro] ?? vaiTro;
}

const MAU_VAI_TRO = {
  admin: "error",
  // MUI Chip chỉ nhận default|primary|secondary|error|info|success|warning —
  // "dark" làm crash: Cannot read properties of undefined (reading 'type').
  ban_giam_doc: "secondary",
  ke_toan: "info",
  nhan_vien: "success",
  kho: "warning",
};

export function mauVaiTro(vaiTro) {
  return MAU_VAI_TRO[vaiTro] ?? "secondary";
}

export const DANH_SACH_VAI_TRO = Object.keys(NHAN_VAI_TRO);
